import { createElement } from 'react';
import './index.scss';
const processContent = (content) => {
    if (typeof content !== 'string') {
        return '';
    }
    return content.replace(/\\/g, '');
};
const RichText = (props) => {
    const { content, dataList, ...otherProps } = props;
    return (createElement("div", { className: "rich-text", ...otherProps }, dataList && dataList.length > 0 ? (dataList.map((item, index) => {
        return (createElement("div", { key: index, dangerouslySetInnerHTML: { __html: processContent(item.content) } }));
    })) : (createElement("div", { dangerouslySetInnerHTML: { __html: processContent(content) } }))));
};
RichText.displayName = 'RichText';
export default RichText;
